/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetExtractUsageRequest = {
  startTime: number;
  endTime?: number | undefined;
  bucketWidth?: components.BucketWidth | undefined;
  limit?: number | undefined;
  page?: string | undefined;
  userIds?: Array<string> | undefined;
  externalUserIds?: Array<string> | undefined;
  allOrgs?: string | undefined;
  orgIds?: Array<string> | undefined;
  groupBy?: Array<components.ExtractGroupBy> | undefined;
  models?: Array<string> | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type GetExtractUsageData = {
  object: "bucket";
  /**
   * Unix timestamp of bucket start (inclusive)
   */
  startTime: number;
  /**
   * Unix timestamp of bucket end (exclusive)
   */
  endTime: number;
  /**
   * Array of usage results for this time bucket
   */
  results: Array<any | null>;
};

/**
 * OK
 */
export type GetExtractUsageResponseBody = {
  object: "page";
  data: Array<GetExtractUsageData>;
  /**
   * Whether there are more pages
   */
  hasMore: boolean;
  /**
   * Cursor for next page, null if no more pages
   */
  nextPage: string | null;
};

/** @internal */
export const GetExtractUsageRequest$inboundSchema: z.ZodType<
  GetExtractUsageRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start_time: z.number().int(),
  end_time: z.number().int().optional(),
  bucket_width: components.BucketWidth$inboundSchema.default("1d"),
  limit: z.number().int().optional(),
  page: z.string().optional(),
  user_ids: z.array(z.string()).optional(),
  external_user_ids: z.array(z.string()).optional(),
  all_orgs: z.string().optional(),
  org_ids: z.array(z.string()).optional(),
  group_by: z.array(components.ExtractGroupBy$inboundSchema).optional(),
  models: z.array(z.string()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
    "bucket_width": "bucketWidth",
    "user_ids": "userIds",
    "external_user_ids": "externalUserIds",
    "all_orgs": "allOrgs",
    "org_ids": "orgIds",
    "group_by": "groupBy",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetExtractUsageRequest$Outbound = {
  start_time: number;
  end_time?: number | undefined;
  bucket_width: string;
  limit?: number | undefined;
  page?: string | undefined;
  user_ids?: Array<string> | undefined;
  external_user_ids?: Array<string> | undefined;
  all_orgs?: string | undefined;
  org_ids?: Array<string> | undefined;
  group_by?: Array<string> | undefined;
  models?: Array<string> | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetExtractUsageRequest$outboundSchema: z.ZodType<
  GetExtractUsageRequest$Outbound,
  z.ZodTypeDef,
  GetExtractUsageRequest
> = z.object({
  startTime: z.number().int(),
  endTime: z.number().int().optional(),
  bucketWidth: components.BucketWidth$outboundSchema.default("1d"),
  limit: z.number().int().optional(),
  page: z.string().optional(),
  userIds: z.array(z.string()).optional(),
  externalUserIds: z.array(z.string()).optional(),
  allOrgs: z.string().optional(),
  orgIds: z.array(z.string()).optional(),
  groupBy: z.array(components.ExtractGroupBy$outboundSchema).optional(),
  models: z.array(z.string()).optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
    bucketWidth: "bucket_width",
    userIds: "user_ids",
    externalUserIds: "external_user_ids",
    allOrgs: "all_orgs",
    orgIds: "org_ids",
    groupBy: "group_by",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getExtractUsageRequestToJSON(
  getExtractUsageRequest: GetExtractUsageRequest,
): string {
  return JSON.stringify(
    GetExtractUsageRequest$outboundSchema.parse(getExtractUsageRequest),
  );
}
export function getExtractUsageRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetExtractUsageRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetExtractUsageRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetExtractUsageRequest' from JSON`,
  );
}

/** @internal */
export const GetExtractUsageData$inboundSchema: z.ZodType<
  GetExtractUsageData,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("bucket"),
  start_time: z.number().int(),
  end_time: z.number().int(),
  results: z.array(z.nullable(z.any())),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
  });
});
/** @internal */
export type GetExtractUsageData$Outbound = {
  object: "bucket";
  start_time: number;
  end_time: number;
  results: Array<any | null>;
};

/** @internal */
export const GetExtractUsageData$outboundSchema: z.ZodType<
  GetExtractUsageData$Outbound,
  z.ZodTypeDef,
  GetExtractUsageData
> = z.object({
  object: z.literal("bucket"),
  startTime: z.number().int(),
  endTime: z.number().int(),
  results: z.array(z.nullable(z.any())),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
  });
});

export function getExtractUsageDataToJSON(
  getExtractUsageData: GetExtractUsageData,
): string {
  return JSON.stringify(
    GetExtractUsageData$outboundSchema.parse(getExtractUsageData),
  );
}
export function getExtractUsageDataFromJSON(
  jsonString: string,
): SafeParseResult<GetExtractUsageData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetExtractUsageData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetExtractUsageData' from JSON`,
  );
}

/** @internal */
export const GetExtractUsageResponseBody$inboundSchema: z.ZodType<
  GetExtractUsageResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("page"),
  data: z.array(z.lazy(() => GetExtractUsageData$inboundSchema)),
  has_more: z.boolean(),
  next_page: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    "has_more": "hasMore",
    "next_page": "nextPage",
  });
});
/** @internal */
export type GetExtractUsageResponseBody$Outbound = {
  object: "page";
  data: Array<GetExtractUsageData$Outbound>;
  has_more: boolean;
  next_page: string | null;
};

/** @internal */
export const GetExtractUsageResponseBody$outboundSchema: z.ZodType<
  GetExtractUsageResponseBody$Outbound,
  z.ZodTypeDef,
  GetExtractUsageResponseBody
> = z.object({
  object: z.literal("page"),
  data: z.array(z.lazy(() => GetExtractUsageData$outboundSchema)),
  hasMore: z.boolean(),
  nextPage: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    hasMore: "has_more",
    nextPage: "next_page",
  });
});

export function getExtractUsageResponseBodyToJSON(
  getExtractUsageResponseBody: GetExtractUsageResponseBody,
): string {
  return JSON.stringify(
    GetExtractUsageResponseBody$outboundSchema.parse(
      getExtractUsageResponseBody,
    ),
  );
}
export function getExtractUsageResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetExtractUsageResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetExtractUsageResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetExtractUsageResponseBody' from JSON`,
  );
}
